import React from 'react';
import Link from 'gatsby-link';

import styles from './footer.module.scss';

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.info}>
      <div className={styles.links}>
        <a
          href="privacy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          隱私權條款與免責聲明
        </a>
      </div>

      <div className={styles.contact}>
        <h5>聯絡</h5>

        <ul>
          <li>Partner Studio: <a href="https://patw.me" target="_blank" rel="noopener noreferrer">https://patw.me</a></li>
          <li>Email: <a href="mailto:patw.hi+f2efindjobs@gmail.com">patw.hi@gmail.com</a></li>
        </ul>
      </div>
    </div>

    <div className={styles.copyright}>
      <span>
        &copy; 2017-2019 <a href="https://patw.me" target="_blank" rel="noopener noreferrer">PARTNER STUDIO</a> All Rights Reserved.
      </span>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js